import APIS from 'src/constants/ApiConfig';
import { BaseResult, IPageResult } from 'src/entity/BaseResult';
import { PromotionListItem, PromotionSearchParam, PromotionStatusParams} from 'src/entity/PromotionEntity';
import HttpService from 'src/services/HttpService';
import { message } from 'antd';
import { PaginationProps } from 'antd/lib/pagination';
import { PromotOrderTypes } from 'src/entity/PromotionEntity';
import I18N from 'src/services/I18NService';

/**
 * 促销订单字典
 */
export const OrderTypeList = [
  {name: '库存订单', value: PromotOrderTypes.StockOrder},
];


const listApi = APIS.domainApi(APIS.promotion.list);
const statusApi = APIS.domainApi(APIS.promotion.status);
const verifyCodeApi = APIS.domainApi(APIS.promotion.verifyCode);

/**
 * 促销设置service
 * @class PromotionService
 */
class PromotionService {
  
  /**
   * 初始化分页器配置
   */
  initPagination(current = 1, pageSize = 10,) {
    const result: PaginationProps = {
      total: 0,
      defaultCurrent: 1,
      current,
      defaultPageSize: pageSize,
      pageSize,
      pageSizeOptions: ['10', '20', '30', '40'],
      showSizeChanger: true,
    };
    return result;
  }

  /**
   * 根据条件查询促销列表
   * @memberof PromotionService
   */
  fetchPromotions = async (query?: Partial<PromotionSearchParam>): Promise<IPageResult<PromotionListItem[]> | undefined> => {
    const param: Partial<PromotionSearchParam> =  query ? {...query} : {limit: 20, offset: 0};
    let result: IPageResult<PromotionListItem[]> | undefined;
    try {
      const res: BaseResult<IPageResult<PromotionListItem[]>> = await HttpService.get(listApi, param);
      if (res && res.success) {
        result = res.data;
      }
    } catch (error) {
      console.error('fetchPromotions faild: ', error);
      message.error('获取促销列表失败');
      throw error;
    }
    return result;
  };

  /**
   * 切换促销[启用|禁用]状态
   * @memberof PromotionService
   * @param uuid: 职员uuid
   * @param isActive: 需要切换的状态
   */
   togglePromotionStatus = async (params: PromotionStatusParams): Promise<boolean> => {
    let isSuccessed = false;
    try {
      const res = await HttpService.post(statusApi, params);
      if (!!res && res.success) {
        isSuccessed = true;
        const tips = params.is_active ? '启用成功' : '禁用成功';
        message.success(tips);
      } else if (!!res.msg) {
        message.error(res.msg);
      }
    } catch (error) {
      console.error('fetchDrugstoreList: ', error);
    }
    return isSuccessed;
  };

  /**
   * 发送短信验证码
   */
  async sendVerifyCode(params: {phone: string}) {
    let isSuccessed = false;
    try {
      const res = await HttpService.post(verifyCodeApi, params);
      if (!!res && res.success) {
        isSuccessed = true;
        const tips = I18N.get('login_get_verify');
        message.success(tips);
      } else if (!!res.msg) {
        message.error(res.msg);
      }
    } catch (error) {
      console.error('sendVerifyCode: ', error);
    }
    return isSuccessed;
  }
}

export default new PromotionService();



// WEBPACK FOOTER //
// ./src/services/PromotionService.ts